import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeoutComponent } from './timeout/timeout.component';
import { RouterModule } from '@angular/router';
import { Error401Component } from './error401/error401.component';
import { UnableToLoadPageComponent } from './unable-to-load-page/unable-to-load-page.component';

@NgModule({
  declarations: [TimeoutComponent, Error401Component, UnableToLoadPageComponent],
  imports: [CommonModule, RouterModule]
})
export class ErrorPagesModule {}
